import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=ad942cb6&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=ad942cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad942cb6",
  null
  
)

export default component.exports